import {makeStyles} from "@material-ui/core";

export default function css() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        }
    }));
}